import { useEffect, useState } from "react";
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import FormDrawer from "components/__new/common/form-drawer";
import { Input, SelectInput } from "components/__new/common/form";
import { useDispatch } from "react-redux";
import { getAllBanks } from "store/ui/banks/action";
import { getProviders } from "store/entities/billPayment/action";
import { toast } from "react-toastify";


const CsvEntryEditModal = ({isOpen, setIsOpen, selectedItem, updateCsvEntry, providers, loading}) => {
    const dispatch  = useDispatch()
    const [isConfirmEditOpen, setIsConfirmEditOpen] = useState(false);
    
    const [form, setForm] = useState({
        amount: "",
        phone: "",
        accountType: "",
        network: "",
        account: "",
        biller: "",
        slug: "",
        meterNumber: ""
    });
    
    const transformedProviders = providers?.map(obj => {
        const formattedName = obj.name.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
        return {
            ...obj,
            label: formattedName
        };
    });
    
    const onSubmit = () => {
        if(!form?.accountType || form.accountType?.length < 1) {
            toast.error("Please select a meter type")
        } else {
            updateCsvEntry(form);
            setForm({});
            setIsOpen(false);
        }
    }

    useEffect(() => {
        if(selectedItem !== null && selectedItem !== undefined) {
            setForm({
                id: selectedItem?.id,
                amount: selectedItem?.amount,
                phone: selectedItem?.phone,
                account: selectedItem?.meterNumber,
                slug: selectedItem?.slug,
                biller: selectedItem?.biller,
                meterNumber: selectedItem?.meterNumber,
                accountType: selectedItem?.meterType?.toLowerCase()
            });
        }
    }, [selectedItem])
    
    useEffect(() => {
        dispatch(getAllBanks());
        dispatch(getProviders())
        // eslint-disable-next-line
    }, [])
    
    return (
        <>
            <SaveEditsModal 
                isOpen={isConfirmEditOpen}
                setIsOpen={setIsConfirmEditOpen}
                onProceed={() => {
                    setIsConfirmEditOpen(false);
                    onSubmit();
                }}
            />
            
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={() => {}}>
                <div className='w-full p-7'>
                    <div className='mb-6'>
                        <div className="flex items-center justify-between">
                            <div className="text-xl font-bold">
                                Edit This Entry
                            </div>
                            
                            <div onClick={() => setIsOpen(false)} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                                <IconTimes width={30} />
                            </div>
                        </div>
                    </div>
                    
                    <div className="w-full space-y-5">
                        
                        <Input 
                            min={11}
                            max={11}
                            label="Meter Number"
                            
                            value={form?.meterNumber || ""}
                            onChange={(e) => setForm({...form, meterNumber: e.target.value, account: e.target.value})}
                        />
                        
                        <Input 
                            label="Recipient"
                            value={form?.phone || ""}
                            onChange={(e) => setForm({...form, phone: e.target.value})}
                        />
                        
                        <SelectInput label="Biller" value={form.biller || ""} onChange={(e) => setForm({...form, biller: e.target.value, slug: e.target.value.toLowerCase().replace(/\s+/g, '_')})}>
                            <option value="">Select Biller</option>
                            {transformedProviders?.map((provider) => (
                                <option key={provider.name} value={provider.label}>{provider.label}</option>
                            ))}
                        </SelectInput>
                        
                        <div className="mt-6">
                            <SelectInput label="Meter Type" value={form.accountType || ""} onChange={(e) => {setForm({...form, accountType: e.target.value})}}>
                                <option value="" disabled>Select</option>
                                <option value="prepaid">Prepaid</option>
                                <option value="postpaid">Postpaid</option>
                            </SelectInput>
                        </div>
                        
                        <div className="form-group">
                            <label>Amount </label>
                                <input
                                    type="number"
                                    id="prl-input"
                                    className="form-input"
                                    value={form?.amount || ""}
                                    placeholder="0.00"
                                    onChange={(e) => setForm({...form, amount: e.target.value})}
                                />
                        </div>
                    </div>
                    
                    <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                        <button onClick={() => setIsOpen(false)} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <button disabled={loading} onClick={() => setIsConfirmEditOpen(true)} className="btn btn-ep-primary">
                            Save Changes
                        </button>
                    </div>
                </div>
            </FormDrawer>
        </>
    )
}

const SaveEditsModal = ({isOpen, setIsOpen, onProceed}) => {

return (
    <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={() => {}}>
        <div className="p-7 pb-4">
            <div className='pb-2 mb-2'>
                <div className="flex items-center justify-between">
                    <div className="font-bold">
                        Save All Changes
                    </div>
                    
                    <div onClick={() => setIsOpen(false)} className='w-5 h-5 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                        <IconTimes width={10} />
                    </div>
                </div>
                
                
                <div className="my-5 text-ep-gray-600">
                    Are you sure you want to perform this action?
                </div>
                
                
                <div className="w-full flex items-center justify-center">
                    <button onClick={() => setIsOpen(false)} className="btn btn-transparent-primary w-2/4 mr-3">
                        No
                    </button>
                    
                    <button onClick={onProceed} className="btn btn-ep-primary w-2/4">
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </FormDrawer>
    )
}

export default CsvEntryEditModal;